import { gql } from '@apollo/client'
import { useEffect, useState } from 'react'
import { Table, Input, Label, Spinner, Alert } from 'reactstrap'
import { EMAIL_TIMEKEEPERS_REPORT_QUERY, TIME_PERIODS_QUERY } from '../../../graphql'
import { enterKeyHandler, handleGraphQLErrors } from '../../../utils'
import useForm from '../../CustomHooks/FormHook'
import MessageCard from '../../MessageCard/MessageCard'
import '../Custom.css'
import FormHeading from '../FormHeading'
import FormSubmitButton from '../FormSubmitButton'

export const TIME_PERIODS = gql(TIME_PERIODS_QUERY)
export const EMAIL_TIMEKEEPERS_REPORT = gql(EMAIL_TIMEKEEPERS_REPORT_QUERY)

export default function EmailTimekeeperReport() {
  console.log('EmailTimekeeperReport rendered')

  const initialInputs = {
    timePeriod: '',
    option: '',
  }

  const [items, setItems] = useState()
  const { inputs, handleInputChange, handleSubmit } = useForm(initialInputs, submitSearch, enterKeyHandler(submitSearch))
  const [message, setMessage] = useState(false)
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    async function fetchItems() {
      try {
        const { data, errors } = await window.apolloClient.query({ query: TIME_PERIODS })
        if (data.timePeriods) {
          const menuItems = []
          for (let item of data.timePeriods) {
            menuItems.unshift(<option key={item.timePeriod} value={item.timePeriod}>{item.displayName}</option>)
          }
          inputs.timePeriod = menuItems[0].props.value
          setItems(menuItems)
        }
        if (errors) {
          setGraphQLErrors(errors)
        }
      } catch (err) {
        handleGraphQLErrors(err, setGraphQLErrors)
      }
    }
    if (!items) {
      fetchItems()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items])
  
  async function submitSearch() {
    console.log('EmailTimekeeperReport.submitSearch', inputs)
    const { data, errors } = await window.apolloClient.query({ query: EMAIL_TIMEKEEPERS_REPORT, variables: { timePeriod: inputs.timePeriod, option: inputs.option } })
    if (data) {
      console.log(data)
    }  
    if (errors) {
      setGraphQLErrors(errors)
    }
    setMessage(true)
  }

  if (message) {
    return (<MessageCard
      title="Email Timekeeper Reports"
      message="The timekeeper reports have been sent."
      buttonText="OK"
      clickUrl="/home" 
    /> )
  }

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (items) {
    return (
      <div className="custom-scroll">
        <form className="form" onSubmit={handleSubmit}>
          <div>
            <Table bordered className="custom-table custom-form-table">
              <FormHeading headingText='Send Timekeeper Reports' />
              <tbody>
                <tr >
                  <td><Label><b>Time Period</b></Label></td>
                  <td>
                    <Input name='timePeriod' type='select' onChange={handleInputChange}>{items}</Input>
                  </td>
                </tr>
                <tr >
                  <td><Label><b>Report</b></Label></td>
                  <td>
                    <Input name='option' type='select' onChange={handleInputChange}>ß
                      <option value="">Individual and Management</option>
                      <option value="I">Individual Only</option>
                      <option value="M">Management Only</option>
                    </Input>
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
          <FormSubmitButton label="Send Reports" />
        </form>
      </div>
    )
  } else {
    return <Spinner />
  }
}